/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

export const getIsPromotionAPILoading = (state) => state?.mfeCheckout?.payment?.promotion?.isPromotionAPILoading || false;
export const getPromotionRedirectionDetails = (state) => state?.mfeCheckout?.payment?.promotion?.affiliatePartner || {};

// banner codes
export const getBannerCodesAttempted = (state) => {
    if (state?.mfeCheckout?.payment?.promotion) {
        return state.mfeCheckout.payment.promotion.bannerCodesAttempted || [];
    }
    return [];
};
